import {SurveySectionsRenderingModel} from "data/models/survey/base";
import {DESCRIPTION_CLASS, PARAGRAPH_CLASS, TITLE_CLASS} from "components/Survey/classes";

export const WhatMakesYouSpecialTitle = ({businessName}: SurveySectionsRenderingModel) =>
    <span className={TITLE_CLASS}>What makes {businessName} special?</span>;

export const WhatMakesYouSpecialParagraph1 = () => (
    <p className={PARAGRAPH_CLASS}>
      <span className={DESCRIPTION_CLASS}>
      The most successful and authentic brands reflect the character of the product,
      service, or organization itself.
    </span>
    </p>
);

export const WhatMakesYouSpecialParagraph2 = ({businessName}: SurveySectionsRenderingModel) => (
    <p className={PARAGRAPH_CLASS}>
      <span className={DESCRIPTION_CLASS}>
        We’re going to ask some questions so we can learn just
        how special {businessName} is <a
          href={"https://brandingcompass.com/branding/get-the-most-out-of-your-branding-compass-workbook/"}
          target={"_blank"}>(<span className={"underline"}>this is why</span>)</a>. We’ll use your answers to make recommendations on the best colors and fonts for your brand.
      </span>
    </p>
);

export const ServiceDescriptionWordsTitle = ({businessName}: SurveySectionsRenderingModel) =>
    <span className={TITLE_CLASS}>Describe the service experience at {businessName}.</span>;

  export const EventDescriptionWordsQuestion = ({businessName}: SurveySectionsRenderingModel) =>
    <span className={TITLE_CLASS}>Does {businessName} do in-person or virtual events?</span>;
